import { fetchWrapper } from '@/_helpers';

const BASE_URL = 'evv/employee-pay-rates';

export const evvApi = {
    getEmployeeStaffRates: (employeeId, { team } = {}) => {
        const queryParams = team ? `?team=${team}` : '';
        return fetchWrapper.get(`${BASE_URL}/employee/${employeeId}${queryParams}`);
    },
    createOrUpdateEmployeeStaffRates: (employeeId, data, { team } = {}) => {
        const queryParams = team ? `?team=${team}` : '';
        return fetchWrapper.post(`${BASE_URL}/employee/${employeeId}${queryParams}`, data);
    },
};
